export { default } from './HardwaresLayout';
